(() => {
  const engrBlock = document.getElementById('engraving-option');
  if (!engrBlock) return;
  const sectionId = engrBlock.getAttribute('data-section-id') || 'default';
  window.__engrBound = window.__engrBound || new Set();
  if (window.__engrBound.has(sectionId)) return;
  window.__engrBound.add(sectionId);

  const infoModal = document.getElementById('engraving-info-modal');
  const uploadModal = document.getElementById('engraving-upload-modal');

  const hiddenFile  = () => engrBlock.querySelector('[data-engraving-file]');
  const detailsWrap = () => engrBlock.querySelector('.engraving-details');
  const detailsName = () => engrBlock.querySelector('[data-file-name]');
  const dz          = () => uploadModal?.querySelector('[data-upload-dropzone]');
  const input       = () => document.getElementById('engraving-file-input');
  const errorEl     = () => uploadModal?.querySelector('.engraving-upload__error');
  const iconWrap    = () => uploadModal?.querySelector('.engraving-upload__icon-wrap');
  const headline    = () => uploadModal?.querySelector('.engraving-upload__headline');
  const subline     = () => uploadModal?.querySelector('.engraving-upload__sub');
  const selectedBox = () => uploadModal?.querySelector('.engraving-upload__selected');

  const productForm = engrBlock.closest('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
  if (!productForm) return;
  const addBtn = productForm.querySelector('[data-add-to-cart]') || productForm.querySelector('.product-form__cart-submit');

  const tUploading = uploadModal?.dataset.msgUploading || 'Nahrávání...';
  const tOf        = uploadModal?.dataset.msgOf || 'z';
  const tSelected  = uploadModal?.dataset.labelSelected || 'Vybraný soubor:';
  const tFileLabel = uploadModal?.dataset.labelFile || 'Soubor:';
  const tRemoveAria= uploadModal?.dataset.ariaRemove || 'Odebrat soubor';

  let CFG = { enabled:false, variant_id:null };
  try {
    const cfgEl = document.getElementById(`engraving-bundle-data-${sectionId}`);
    if (cfgEl && cfgEl.textContent) CFG = JSON.parse(cfgEl.textContent);
  } catch(_) {}

  const show = (m)=>{ if(!m) return; m.style.display='grid'; m.classList.add('is-open'); requestAnimationFrame(()=>m.classList.add('is-visible')); m.removeAttribute('aria-hidden'); };
  const hide = (m)=>{ if(!m) return; const done=()=>{ m.style.display='none'; m.classList.remove('is-open'); m.removeEventListener('transitionend',done); }; m.classList.remove('is-visible'); m.addEventListener('transitionend',done); setTimeout(done,300); m.setAttribute('aria-hidden','true'); };
  function unlockScroll() {
    const top = parseInt((document.body.style.top || '0').replace('px',''),10);
    if (!isNaN(top) && top < 0) window.scrollTo(0, -top);
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.top = '';
    ['no-scroll','overflow-hidden','modal-open','js-lock-scroll','is-locked','lock-scroll','cart-drawer-open'].forEach(c=>{
      document.documentElement.classList.remove(c);
      document.body.classList.remove(c);
    });
  }
  const ensureUnlock = ()=>{ unlockScroll(); setTimeout(unlockScroll, 400); };

  let timer=null, pending=null, currentFile=null;

  function formatBytes(bytes){ const k=1024; if (Math.abs(bytes)<k) return `${bytes} B`; const u=['KB','MB','GB','TB']; let i=-1,v=bytes; do{v/=k;++i;}while(Math.abs(v)>=k&&i<u.length-1); const d=v<10?1:0; return `${v.toFixed(d)} ${u[i]}`; }
  function clearProgress(){ dz()?.querySelector('.engr-progress-card')?.remove(); }
  function hidePrompt(){ if (iconWrap()) iconWrap().style.display='none'; if (headline()) headline().style.display='none'; if (subline()) subline().style.display='none'; }
  function showPrompt(){ if (iconWrap()) iconWrap().style.display=''; if (headline()) headline().style.display=''; if (subline()) subline().style.display=''; }
  function resetUIToPrompt(){ const i=input(); if (i) i.value=''; clearProgress(); const err=errorEl(); if (err) err.hidden=true; dz()?.classList.remove('has-error'); const sel=selectedBox(); if (sel){ sel.hidden=true; sel.innerHTML=''; sel.removeAttribute('data-saved'); } showPrompt(); if (timer){ clearInterval(timer); timer=null; } }
  function setChecked(on){
    const cb = engrBlock.querySelector('.engraving-checkbox');
    if (on){ engrBlock.classList.add('is-selected'); cb?.setAttribute('aria-pressed','true'); }
    else   { engrBlock.classList.remove('is-selected'); cb?.setAttribute('aria-pressed','false'); }
  }

  const folderSVG = `
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" aria-hidden="true">
      <path d="M9.6.5h17.79L42.7 15.81V43.2A4.3 4.3 0 0 1 38.4 47.5H9.6A4.3 4.3 0 0 1 5.3 43.2V4.8A4.3 4.3 0 0 1 9.6.5Z" fill="white" stroke="#E4E7EC"/>
      <path d="M27.6 9.6V0L43.2 15.6H33.6a6 6 0 0 1-6-6Z" fill="#CED2DA"/>
      <path d="M6.3 27a2 2 0 0 1 2-2h13a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H8.3a2 2 0 0 1-2-2v-9Z" fill="#E4E7EC"/>
    </svg>`;
  const removeSVG = `
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M6.758 17.243 12 12m0 0 5.243-5.243M12 12 6.758 6.757M12 12l5.243 5.243" stroke="#637083" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`;

  function renderProgress(file){
    const dzEl = dz(); if (!dzEl) return null;
    const totalText = formatBytes(file.size);
    const extTxt = (file.name.match(/\.([a-z0-9]+)$/i)?.[1] || 'file').toUpperCase();
    const card = document.createElement('div');
    card.className='engr-progress-card';
    card.innerHTML = `
      <div class="engr-progress-card">
        <div class="engr-filebadge" aria-hidden="true">
          <div class="engr-fileicon48">
            ${folderSVG}
            <span class="engr-fileext engr-fileext--badge">.${extTxt}</span>
          </div>
        </div>
        <div class="engr-progress-head">
          <div class="engr-uploading">${tUploading}</div>
          <div class="engr-percent">
            <span class="engr-pct">0%</span>
            <span class="engr-spinner">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M12 4.75V6.25M17.126 6.873l-1.06 1.06M19.25 12H17.75M17.126 17.127l-1.06-1.061M12 17.75V19.25M7.934 16.066 6.874 17.127M6.25 12H4.75M7.934 7.934 6.874 6.873" stroke="#CED2DA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </span>
          </div>
        </div>
        <div class="engr-track"><div class="engr-bar"></div></div>
        <div class="engr-amount"><span class="engr-loaded">0 B</span> ${tOf} ${totalText}</div>
      </div>`;
    dzEl.appendChild(card);
    return { bar: card.querySelector('.engr-bar'), pct: card.querySelector('.engr-pct'), loaded: card.querySelector('.engr-loaded'), totalBytes: file.size };
  }

  function removeFile(){
    currentFile = null;
    if (detailsWrap()) detailsWrap().hidden = true;
    if (detailsName()) detailsName().textContent = '';
    if (hiddenFile()) hiddenFile().value = '';
    engrBlock.classList.remove('has-file');
    engrBlock.removeAttribute('data-saved-size');
    setChecked(false);
  }
  function hydrateModalFromSaved(){
    resetUIToPrompt();
    const savedName = hiddenFile()?.value || '';
    if (!savedName) return;
    hidePrompt();
    const sel = selectedBox(); if (!sel) return;
    const sizeText = engrBlock?.dataset.savedSize || '';
    sel.innerHTML = `
      <div class="engr-selected">
        <span>${tFileLabel} ${savedName}${sizeText ? ` <span class="engr-selected-size">(${sizeText})</span>` : ''}</span>
        <button type="button" class="engr-remove" data-remove-file aria-label="${tRemoveAria}">${removeSVG}</button>
      </div>`;
    sel.hidden = false;
    sel.setAttribute('data-saved','1');
    pending = null;
  }
  const openUploadModal = ()=>{ hydrateModalFromSaved(); show(uploadModal); };

  document.addEventListener('click', (e) => {
    const isCheckbox = e.target.closest('.engraving-checkbox');
    const isLabel    = e.target.closest('.engraving-label');
    if (!(isCheckbox || isLabel)) return;
    e.preventDefault();
    if (hiddenFile()?.value){ removeFile(); return; }
    openUploadModal();
  }, true);

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-modal-trigger="info"]')) { e.preventDefault(); show(infoModal); return; }
    if (e.target.closest('[data-modal-trigger="upload"]')) { e.preventDefault(); openUploadModal(); return; }
    if (e.target.closest('#engraving-info-modal [data-close]')) { e.preventDefault(); hide(infoModal); ensureUnlock(); return; }
    if (e.target.closest('#engraving-upload-modal [data-close]')) { e.preventDefault(); hide(uploadModal); ensureUnlock(); return; }
    if (e.target.classList?.contains('engraving-info-modal__overlay')) { hide(infoModal); ensureUnlock(); return; }
    if (e.target.classList?.contains('engraving-upload-modal__overlay')) { hide(uploadModal); ensureUnlock(); return; }
    if (e.target.closest('#engraving-info-modal [data-action="open-upload"]')) { e.preventDefault(); hide(infoModal); openUploadModal(); return; }
    if (e.target.closest('#engraving-upload-modal [data-action="save-upload"]')) { e.preventDefault(); commitUpload(); return; }
  }, true);

  uploadModal?.addEventListener('click', (e) => {
    const rm = e.target.closest('[data-remove-file]');
    if (!rm) return;
    e.preventDefault();
    removeFile();
    resetUIToPrompt();
    showPrompt();
  });

  document.addEventListener('change', (e) => {
    if (e.target?.id !== 'engraving-file-input') return;
    const i = input(); const f = i?.files && i.files[0];
    if (timer) { clearInterval(timer); timer = null; }
    clearProgress();
    if (!f) return;

    const err = errorEl(); const dzEl = dz();
    const max = 20 * 1024 * 1024;
    const okType = /\.(svg|ai|eps|pdf|jpg|jpeg|png)$/i.test(f.name);

    if (!okType) { if (err){ err.textContent = err.dataset.msgType || 'Nepodporovaný typ souboru.'; err.hidden=false; } dzEl?.classList.add('has-error'); i.value=''; return; }
    if (f.size > max) { if (err){ err.textContent = err.dataset.msgSize || 'Soubor je příliš velký. Max 20MB.'; err.hidden=false; } dzEl?.classList.add('has-error'); i.value=''; return; }

    if (err) err.hidden = true; dzEl?.classList.remove('has-error');
    selectedBox().hidden = true; selectedBox().innerHTML = ''; selectedBox().removeAttribute('data-saved');
    hidePrompt();

    const ui = renderProgress(f); if (!ui) return;
    let p = 0;
    const duration = Math.min(3500, Math.max(1200, (f.size/(1024*1024))*40));
    const stepMs = 80; const inc = (100*stepMs)/duration;

    timer = setInterval(() => {
      p = Math.min(100, p + inc);
      const loadedBytes = Math.round((p/100) * ui.totalBytes);
      ui.pct.textContent = `${Math.floor(p)}%`;
      ui.bar.style.width = `${p}%`;
      ui.loaded.textContent = formatBytes(loadedBytes);
      if (p >= 100) {
        clearInterval(timer); timer = null;
        setTimeout(() => {
          const sizeText = formatBytes(ui.totalBytes);
          selectedBox().innerHTML = `
            <div class="engr-selected">
              <span>${tSelected} ${f.name} <span class="engr-selected-size">(${sizeText})</span></span>
              <button type="button" class="engr-remove" data-remove-file aria-label="${tRemoveAria}">${removeSVG}</button>
            </div>`;
          selectedBox().hidden = false;
          clearProgress();
          pending = { file: f, sizeText, sizeBytes: ui.totalBytes };
        }, 200);
      }
    }, stepMs);
  });

  function commitUpload(){
    if (!pending) { hide(uploadModal); ensureUnlock(); return; }
    if (pending.remove){ removeFile(); resetUIToPrompt(); showPrompt(); return; }
    if (pending.file){
      currentFile = pending.file;
      if (detailsWrap()) detailsWrap().hidden=false;
      if (detailsName()) detailsName().textContent=pending.file.name;
      if (hiddenFile()) hiddenFile().value=pending.file.name;
      engrBlock.classList.add('has-file');
      engrBlock.dataset.savedSize = pending.sizeText;
      setChecked(true);
      pending=null; resetUIToPrompt(); hide(uploadModal); ensureUnlock();
    }
  }

  function getMainVariantId(){ const idInput = productForm?.querySelector('select[name="id"], input[name="id"]'); return idInput ? parseInt(idInput.value,10) : null; }
  function getQuantity(){ const qty = productForm?.querySelector('[name="quantity"], [name="qty"]'); const v = qty ? parseInt(qty.value,10) : 1; return Number.isFinite(v) && v>0 ? v : 1; }
  function getSellingPlan(){ const sp = productForm?.querySelector('[name="selling_plan"]'); return sp && sp.value ? parseInt(sp.value,10) : null; }
  function collectProps(){ const props = {}; productForm?.querySelectorAll('[name^="properties["]').forEach((el)=>{ const m = el.name.match(/^properties\[(.+)\]$/); if (m) props[m[1]] = el.value; }); return props; }

  async function cartAddFormDataWithFile() {
    const mainVarId = getMainVariantId();
    if (!mainVarId) throw new Error('Missing variant id');
    const quantity = getQuantity();
    const sp = getSellingPlan();

    const fd = new FormData();

    fd.append('items[0][id]', String(mainVarId));
    fd.append('items[0][quantity]', String(quantity));
    if (sp) fd.append('items[0][selling_plan]', String(sp));

    const props = collectProps();
    for (const k in props) {
      if (k === 'Engraving file') continue;
      fd.append(`items[0][properties][${k}]`, props[k]);
    }

    if (currentFile) {
      fd.append('items[0][properties][Engraving file]', currentFile.name);
      fd.append('items[0][properties][_Engraving file]', currentFile, currentFile.name);
      fd.append('items[0][properties][_has_engraving]', 'true');
    }

    const bundleEnabled = !!CFG.enabled;
    const bundleVarId = parseInt(CFG.variant_id || '', 10);
    if (bundleEnabled && bundleVarId && currentFile) {
      fd.append('items[1][id]', String(bundleVarId));
      fd.append('items[1][quantity]', String(quantity));
      fd.append('items[1][properties][_engraving_for]', String(mainVarId));
    }

    const res = await fetch('/cart/add.js', {
      method: 'POST',
      body: fd,
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    });
    if (!res.ok) throw new Error('cart add failed');
    return res.json();
  }

  function openCartDrawerIfAny(){
    const opener =
      document.querySelector('[data-cart-drawer-open]') ||
      document.querySelector('[aria-controls="CartDrawer"]') ||
      document.querySelector('[data-open-cart]') ||
      document.querySelector('[data-drawer-id="cart"]');
    if (opener) { opener.click(); ensureUnlock(); }
  }

  const handleAddWithFile = async (beforeDisable, afterEnable) => {
    try {
      beforeDisable?.();
      await cartAddFormDataWithFile();
      openCartDrawerIfAny();
    } catch (_) {
    } finally {
      afterEnable?.();
    }
  };

  if (addBtn) {
    addBtn.addEventListener('click', (e) => {
      if (!currentFile) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      const loader = addBtn.querySelector('[data-loader]');
      const textEl = addBtn.querySelector('[data-add-to-cart-text]');
      handleAddWithFile(
        () => { addBtn.disabled = true; if (loader) loader.classList.remove('hide'); if (textEl) textEl.style.opacity = '0.6'; },
        () => { addBtn.disabled = false; if (loader) loader.classList.add('hide'); if (textEl) textEl.style.opacity = ''; }
      );
    }, true);
  }

  productForm.addEventListener('submit', (e) => {
    if (!currentFile) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    const btns = productForm.querySelectorAll('button, [type="submit"], [data-add-to-cart]');
    handleAddWithFile(
      () => { btns.forEach(b=>b.disabled=true); },
      () => { btns.forEach(b=>b.disabled=false); }
    );
  }, true);

  document.addEventListener('click', (e) => {
    if (e.target.closest('#engraving-upload-modal [data-action="save-upload"]')) {
      e.preventDefault();
      commitUpload();
    }
  }, true);
})();
